import styled from "styled-components";

import { colors } from "../../../consts";

import { TextButton } from "../../../components";

export const FormTextButton = styled(TextButton)`
  ${(props) => props?.red && `color: ${colors.ERROR};`}
`;
